import { connect } from 'react-redux';
import { useAppVisibility } from '@mews/framework';
import { hasError, hasValues } from '../selectors';
import { ScannerWrapper } from './style';
import CameraScanner from './CameraScanner';
import ValuesEditor from './ValuesEditor';

interface Props {
    withError?: boolean;
    withValues?: boolean;
    scope: string;
}

const IdentityDocumentScannerForm = ({ withError, withValues, scope, ...others }: Props) => {
    const editorOpened = withValues && !withError;
    const isAppVisible = useAppVisibility();

    return (
        <ScannerWrapper>
            {/* @ts-expect-error $TSFixMeError: Type '{ scope: any; children?: ReactNode; isOpened: boolean | undefined; }' is not assignable to type 'IntrinsicAttribut... */}
            <CameraScanner isOpened={!editorOpened && isAppVisible} {...others} scope={scope} />
            {/* @ts-expect-error $TSFixMeError: JSX element type 'ValuesEditor' does not have any construct or call signatures. */}
            <ValuesEditor
                isOpened={editorOpened && isAppVisible}
                {...others}
                scope={scope}
                form={`document-and-profile-values-${scope}`}
            />
        </ScannerWrapper>
    );
};

// @ts-expect-error $TSFixMeError: Property 'scope' does not exist on type '{}'.
export default connect((state, { scope }) => ({
    withError: hasError(state, { scope }),
    // @ts-expect-error $TSFixMeError: Expected 0 arguments, but got 2.
    withValues: hasValues(state, { scope }),
    // @ts-expect-error $TSFixMeError: Argument of type 'typeof IdentityDocumentScannerForm' is not assignable to parameter of type 'ComponentType<Matching<{ w...
}))(IdentityDocumentScannerForm);
